<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-66">
            <form ref="product_add" @submit.prevent="addProduct">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <i class="md-icon fas fa-plus"></i>
                        </div>
                        <h4 class="title">Ajout d'un produit</h4>
                    </md-card-header>
                    <product-form :product="product" :errors="errors"></product-form>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning"
                                   @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
import ProductForm from "@/pages/Products/components/ProductForm";

export default {
    name: "ProductAdd",
    components: {
        ProductForm
    },
    data() {
        return {
            product: {
                name: ''
            },
            errors: []
        }
    },
    methods: {
        async addProduct() {
            try {
                this.errors = [];
                await this.$store.dispatch('products/addProduct', this.product)
                await this.$store.dispatch("alerts/success", "Produit ajouté")
                this.goBack()
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped lang="scss">

</style>
